<div *ngIf="leadIdDisplay">

  <div *ngIf="field.frontendLabel=='Lead Id'">


  </div>



  <div *ngIf="field.frontendLabel=='Lead Name'">


    <mat-form-field fxFlex.gt-md="60" fxFlex [formGroup]="group" fxFlex appearance="outline">
      <mat-label>{{field.frontendLabel}}</mat-label>
      <input [attr.guide]="'autocomplete-inp-1' + '__' + sanitizeUrl(url)" type="text" (input)="onInputPaitent($event)"
        [required]="group.controls[field.attributeCode].status == 'INVALID' ? true : false" matInput
        [formControlName]="field.attributeCode" [matAutocomplete]="auto1" [readonly]="isOptionSelected" />

      <mat-icon *ngIf="isOptionSelected" matSuffix (click)="clearInputLead()" style="cursor: pointer;">clear</mat-icon>
      <mat-autocomplete #auto1="matAutocomplete" (closed)="onAutocompleteClosed('LeadName')">
        <mat-option (onSelectionChange)="onLeadSelected($event,option)" *ngFor="let option of leadList"
          [value]="(option.name && option.name.trim()) ? option.name : (option.phoneNumber || option.mobile || option.phone || '')">
          {{ (option.name && option.name.trim()) ? option.name : (option.phoneNumber || option.mobile || option.phone ||
          'No Name') }} - {{option.email || 'No Email'}} - {{option.phoneNumber || 'No Phone'}}
        </mat-option>
        <mat-option
          *ngIf="(group.get(field.attributeCode)?.value || '').toString().trim().length > 0 && (!leadList || leadList.length === 0)"
          disabled>
          No results found
        </mat-option>
      </mat-autocomplete>
      <mat-error *ngIf="group.controls[field.attributeCode].errors?.required">
        Please fill out this field.
      </mat-error>
    </mat-form-field>
  </div>

  <div *ngIf="field.frontendLabel!='Lead Id'&&field.frontendLabel!='Lead Name'
  &&field.frontendLabel!='Company Id'&&field.frontendLabel!='Company'
  &&field.frontendLabel!='Property Id'&&field.frontendLabel!='Property Name'&&field.frontendLabel!='Property'
  &&field.frontendLabel!='Primary Plan'&&field.frontendLabel!='PrimaryPlan'
  &&field.attributeCode!='propertyId'&&field.attributeCode!='propertyName'
  &&field.attributeCode!='PropertyId'&&field.attributeCode!='PropertyName'
  &&field.attributeCode!='primaryPlan'&&field.attributeCode!='PrimaryPlan'">
    <mat-form-field fxFlex.gt-md="60" fxFlex [formGroup]="group" appearance="outline">
      <mat-label>{{field.frontendLabel}}</mat-label>
      <input [attr.guide]="'autocomplete-inp-2' + '__' + sanitizeUrl(url)" [autocomplete]="'off'" trim="blur"
        [required]="group.controls[field.attributeCode].status == 'INVALID' ? true : false" matInput
        [formControlName]="field.attributeCode" />
      <div *ngFor="let validation of field.validations;" ngProjectAs="mat-error">
        <mat-error *ngIf="group.get(field.attributeCode).hasError(validation.name)">{{validation.message}}</mat-error>
      </div>

    </mat-form-field>
  </div>
</div>


<div *ngIf="companyIdDisplay">
  <div *ngIf="field.frontendLabel=='Company Id'">


  </div>

  <div *ngIf="field.frontendLabel=='Company'">
    <mat-form-field fxFlex.gt-md="60" fxFlex [formGroup]="group" fxFlex appearance="outline">
      <mat-label>{{field.frontendLabel}}</mat-label>
      <input [attr.guide]="'autocomplete-inp-3' + '__' + sanitizeUrl(url)" type="text"
        (input)="onCompanyInputPaitent($event)"
        [required]="group.controls[field.attributeCode].status == 'INVALID' ? true : false" matInput
        [formControlName]="field.attributeCode" [matAutocomplete]="auto1"
        [readonly]="isOptionSelected||group.value.CompanyId> 0 " />

      <mat-icon *ngIf="isOptionSelected||group.value.CompanyId>0 " matSuffix (click)="clearInputCompany()"
        style="cursor: pointer;">clear</mat-icon>
      <mat-autocomplete #auto1="matAutocomplete" (closed)="onAutocompleteClosed('Company')">
        <mat-option (onSelectionChange)="onCompanySelected($event,option)" *ngFor="let option of companyList"
          [value]="option.name">
          {{option.name}}</mat-option>
        <mat-option (onSelectionChange)="addNewCompany($event)"
          *ngIf="companyList?.length === 0 && (group.get(field.attributeCode)?.value || group.value.Company || '').toString().trim().length>0">
          <mat-icon color="primary" class="mr-2">add_circle</mat-icon>
          Add "{{ group.get(field.attributeCode)?.value || group.value.Company }}" as a new company
        </mat-option>
        <mat-option
          *ngIf="(group.get(field.attributeCode)?.value || '').toString().trim().length > 0 && (companyList == null || companyList.length === 0) && !(group.value.Company && group.value.Company.trim().length>0)"
          disabled>
          No results found
        </mat-option>

      </mat-autocomplete>



      <mat-error *ngIf="group.controls[field.attributeCode].errors?.required">
        Please fill out this field.
      </mat-error>
    </mat-form-field>
  </div>



</div>

<div *ngIf="propertyIdDisplay">

  <div
    *ngIf="field.attributeCode=='propertyid' || field.attributeCode=='PropertyId' || field.frontendLabel=='Property Id'">

  </div>

  <div
    *ngIf="field.attributeCode=='PropertyName' || field.attributeCode=='propertyName' || field.attributeCode=='Property' || field.attributeCode=='property' || field.attributeCode=='PrimaryPlan' || field.attributeCode=='primaryPlan' || field.frontendLabel=='Property Name' || field.frontendLabel=='Property' || field.frontendLabel=='property' || field.frontendLabel=='Primary Plan' || field.frontendLabel=='PrimaryPlan'">
    <mat-form-field fxFlex.gt-md="60" fxFlex appearance="outline">
      <mat-label>{{field.frontendLabel}}</mat-label>
      <mat-chip-list #chipList>
        <mat-chip *ngFor="let item of selectedProperties" [removable]="true" (removed)="removeProperty(item)">
          {{item.propertyName || item.name}}
          <mat-icon matChipRemove>cancel</mat-icon>
        </mat-chip>
        <input [attr.guide]="'autocomplete-inp-5' + '__' + sanitizeUrl(url)" type="text" #propertyInput
          placeholder="Click to select records" (input)="onPropertyInput($event)"
          [required]="(group.controls[field.attributeCode]?.status == 'INVALID' && (!selectedProperties || selectedProperties.length === 0)) ? true : false"
          matInput [formControl]="propertyCtrl" [matAutocomplete]="auto1" [matChipInputFor]="chipList"
          [matChipInputSeparatorKeyCodes]="separatorKeysCodes" />
      </mat-chip-list>

      <mat-autocomplete #auto1="matAutocomplete" (optionSelected)="onPropertyOptionSelected($event.option.value)">
        <mat-option *ngFor="let option of filteredPropertyList" [value]="option">
          {{option.propertyName || option.name}}
        </mat-option>
        <mat-option
          *ngIf="(propertyCtrl.value || '').toString().trim().length > 0 && (!filteredPropertyList || filteredPropertyList.length === 0)"
          disabled>
          No results found
        </mat-option>
      </mat-autocomplete>
      <mat-error
        *ngIf="group.controls[field.attributeCode]?.errors?.required && (!selectedProperties || selectedProperties.length === 0)">
        Please fill out this field.
      </mat-error>
    </mat-form-field>
  </div>
</div>

<div *ngIf="field.attributeCode=='productId'">


</div>


<div *ngIf="field.attributeCode=='ProductName'">
  <mat-form-field fxFlex.gt-md="60" fxFlex [formGroup]="group" fxFlex appearance="outline">
    <mat-label>{{field.frontendLabel}}</mat-label>
    <input [attr.guide]="'autocomplete-inp-4' + '__' + sanitizeUrl(url)" type="text" (input)="onProductInput($event)"
      [required]="group.controls[field.attributeCode].status == 
      'INVALID' ? true : false" matInput [formControlName]="field.attributeCode" [matAutocomplete]="auto1"
      [readonly]="isOptionSelected||group.value.ProductId> 0 " />

    <button mat-icon-button *ngIf="isOptionSelected || group.value.ProductId > 0" matSuffix aria-label="Clear product"
      (click)="clearInputProduct(); $event.stopPropagation()">
      <mat-icon>clear</mat-icon>
    </button>
    <mat-autocomplete #auto1="matAutocomplete" (closed)="onAutocompleteClosed('ProductName')">
      <mat-option (onSelectionChange)="onProductSelected($event,option)" *ngFor="let option of productList"
        [value]="option.name">
        {{option.name}}</mat-option>
      <mat-option
        *ngIf="(group.get(field.attributeCode)?.value || '').toString().trim().length > 0 && (!productList || productList.length === 0)"
        disabled>
        No results found
      </mat-option>
    </mat-autocomplete>
    <mat-error *ngIf="group.controls[field.attributeCode].errors?.required">
      Please fill out this field.
    </mat-error>
  </mat-form-field>
</div>


<div
  *ngIf="field.attributeCode=='Category' || field.attributeCode=='category' || field.attributeCode=='CategoryName' || field.attributeCode=='categoryName' || field.frontendLabel=='Category'">
  <mat-form-field fxFlex.gt-md="60" fxFlex [formGroup]="group" fxFlex appearance="outline">
    <mat-label>{{field.frontendLabel}}</mat-label>
    <input [attr.guide]="'autocomplete-inp-cat' + '__' + sanitizeUrl(url)" type="text" (input)="onCategoryInput($event)"
      [required]="group.controls[field.attributeCode]?.status == 'INVALID' ? true : false" matInput
      [formControlName]="field.attributeCode" [matAutocomplete]="autoCat"
      [readonly]="isOptionSelected || (group.value.CategoryId > 0 || group.value.category > 0)" />

    <button mat-icon-button *ngIf="isOptionSelected || (group.value.CategoryId > 0 || group.value.category > 0)"
      matSuffix aria-label="Clear category" (click)="clearInputCategory(); $event.stopPropagation()">
      <mat-icon>clear</mat-icon>
    </button>
    <mat-autocomplete #autoCat="matAutocomplete" (closed)="onAutocompleteClosed('Category')">
      <mat-option (onSelectionChange)="onCategorySelected($event,option)" *ngFor="let option of categoryList"
        [value]="option.name">
        {{option.name}}</mat-option>
      <mat-option
        *ngIf="(group.get(field.attributeCode)?.value || '').toString().trim().length > 0 && (!categoryList || categoryList.length === 0)"
        disabled>
        No results found
      </mat-option>
    </mat-autocomplete>
    <mat-error *ngIf="group.controls[field.attributeCode]?.errors?.required">
      Please fill out this field.
    </mat-error>
  </mat-form-field>
</div>


<div *ngIf="!leadIdDisplay
&& !companyIdDisplay 
&& !propertyIdDisplay
&& field.attributeCode !='productId'
&& field.attributeCode !='ProductName'
&& field.attributeCode !='Category'
&& field.attributeCode !='category'
&& field.attributeCode !='CategoryName'
&& field.attributeCode !='categoryName'
&& field.attributeCode !='propertyId'
&& field.attributeCode !='propertyName'
&& field.attributeCode !='PropertyId'
&& field.attributeCode !='PropertyName'
&& field.attributeCode !='primaryPlan'
&& field.attributeCode !='PrimaryPlan'
&& field.frontendLabel !='Property Id'
&& field.frontendLabel !='Property Name'
&& field.frontendLabel !='Property'
&& field.frontendLabel !='Primary Plan'
&& field.frontendLabel !='PrimaryPlan'
&& field.frontendLabel !='Category'
">

  <mat-form-field fxFlex.gt-md="60" fxFlex [formGroup]="group" appearance="outline">
    <mat-label>{{field.frontendLabel}}</mat-label>
    <input [attr.guide]="'select-sel-1' + '__' + sanitizeUrl(url)"
      [required]="group.controls[field.attributeCode].status == 'INVALID' ? true : false" [autocomplete]="'off'"
      matInput [formControl]="displayControl" (input)="onGenericInput($event)" [matAutocomplete]="auto" />
    <mat-icon *ngIf="isOptionSelected" matSuffix (click)="clearGenericField()" style="cursor: pointer;">clear</mat-icon>
    <mat-autocomplete #auto="matAutocomplete" (closed)="onGenericAutocompleteClosed()">
      <mat-option *ngFor="let item of filteredFieldTypeList" (onSelectionChange)="onFieldOptionSelected($event,item)"
        [value]="item.eavAttributeOptionValue[0]?.value">
        {{item.eavAttributeOptionValue[0]?.value}}
      </mat-option>
      <mat-option
        *ngIf="(displayControl.value || '').toString().trim().length > 0 && (!filteredFieldTypeList || filteredFieldTypeList.length === 0)"
        disabled>
        No results found
      </mat-option>
    </mat-autocomplete>

    <div *ngFor="let validation of field.validations;" ngProjectAs="mat-error">
      <mat-error *ngIf="group.get(field.attributeCode).hasError(validation.name)">{{validation.message}}</mat-error>
    </div>
  </mat-form-field>
</div>